// DiscoverFlixMore.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import DiscoverFlixMore from '../component/DiscoverFlixMore.jsx';
import getMeData from '../selector/getMeData.js';
import fetchFeeds from '../action/fetchFeeds.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchUser from '../action/fetchUser.js';
import getUserListFromFeed from '../selector/getUserListFromFeed.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import { FeedNameType } from '../resource/feedConstants.js';
import { getFeedCategory, sanitizeFeedQuery } from '../resource/feedUtils.js';
import getTranslationKey from '../resource/getTranslationKey.js';

const mapStateToProps = (
  state,
  {
    location,
    match: {
      params: { category: paramCategory },
    },
  }
) => {
  const { search } = location;
  const category = getFeedCategory({
    category: paramCategory,
    search,
  });
  const sanitizedCategory = sanitizeFeedQuery({ feedName: category });
  const selectPath = ['home', FeedNameType.MESSAGES, sanitizedCategory];
  const senderIds = getUserListFromFeed(state, selectPath, 'itemIds');
  const nextPage = getListData(state, selectPath, 'nextPage');
  const messageIds = getListData(state, selectPath, 'itemIds');
  return {
    category,
    titleI18nId: getTranslationKey({ key: category }),
    isAuthed: !!getMeData(state, 'id'),
    messageIds,
    isFirstPageFetched: getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetched'
    ),
    isFetching: !!getNetworkingData(
      state,
      [...selectPath, nextPage],
      'isFetching'
    ),
    nextPage,
    isFirstMessageDetailFetched: getNetworkingData(
      state,
      ['messages', messageIds?.[0], 'detail'],
      'isFetched'
    ),
    senderIds,
    isFirstSenderDataFetched: getNetworkingData(
      state,
      ['user', senderIds?.[0]],
      'isFetched'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
    fetchMessageDetail: ({ id, httpProxyHeaders }) =>
      dispatch(fetchMessageDetail({ id, httpProxyHeaders })),
    fetchUser: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUser({ id: userId, httpProxyHeaders })),
    goBack: () => dispatch(goBack()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscoverFlixMore);
